import React from 'react'
import Fragment from '../common/fragment'


function FragmentCQ(props) {
  return (
    <Fragment pos="qqq" {...props}>
      <p>
De las voces también se eleva un humo lleno de saliva. De las profundidades de la
garganta, chimeneas de palabras y silencio.
      </p>
    </Fragment>
  )
}


export default FragmentCQ
